import { SelectionOption, Selection as SelectionType } from '../../../../../../types/Survey/Element'
import { Props } from './types'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import Core from './Core'
import Input from '../../../../../UI/Input/Input'
import { PlusCircleIcon, TrashIcon } from '@heroicons/react/24/solid'
import { getSelectionOptionTemplate } from '../../AddElement/getTemplateElement'
import DNDList from '../../../../../UI/DNDList/DNDList'
import Checkbox from '../../../../../UI/Checkbox/Checkbox'
import RemoveConfirmation from '../../../../../UI/RemoveConfirmation/RemoveConfirmation'
import Number from '../../../../../UI/Input/Number'

const Selection: React.FC<Props<SelectionType>> = ({ element, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const updateOptionOrder = (options: SelectionOption[]) => update({ ...element, options })

  const Add = () => {
    const add = () => {
      const newSlider = getSelectionOptionTemplate()
      update({ ...element, options: [...element.options, newSlider] })
    }

    return (
      <div className="flex gap-1 items-center mt-3 cursor-pointer w-fit" onClick={add}>
        <PlusCircleIcon className="w-10 fill-cyan" />
        <div className="">{t.survey.configuration.selection.add}</div>
      </div>
    )
  }

  const set = (key: keyof SelectionType) => (value: boolean) => update({ ...element, [key]: value })

  const getOptionValue = (uuid: string) => {
    const option = element.options.find((o) => o.uuid === uuid)
    return option ? option.value : ''
  }

  const updateOption = (uuid: string) => (value: string) => {
    const updatedOptions = element.options.map((o) => (o.uuid === uuid ? { ...o, value } : o))
    update({ ...element, options: updatedOptions })
  }

  const remove = (uuid: string) => () => {
    const newOptions = element.options.filter((o) => o.uuid !== uuid)
    update({ ...element, options: newOptions })
  }

  return (
    <div>
      <Core element={element} update={update} />
      <div className="flex flex-row gap-3 items-center">
        <Checkbox label={t.survey.configuration.selection.allowMultiple} checked={element.isMultipleChoice} onChange={set('isMultipleChoice')} />
        {!!element.isMultipleChoice && (
          <>
            <Checkbox
              label={t.survey.configuration.selection.forceMultipleChoiceMax}
              checked={element.forceMultipleChoiceMax}
              onChange={set('forceMultipleChoiceMax')}
            />
            <Number
              label={t.survey.configuration.selection.maxMultipleChoice}
              value={element.maxMultipleChoice}
              onChange={set('maxMultipleChoice')}
            />
          </>
        )}
      </div>
      <DNDList
        orderUpdateCallback={updateOptionOrder}
        invert
        items={element.options.map((o: SelectionOption, index: number) => {
          return {
            id: o.uuid,
            data: o,
            content: (
              <div key={o.uuid} className="flex flex-row items-center bg-lightGray border-b border-cyan border-opacity-20 py-2 px-2 gap-3">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-6 aspect-square bg-cyan rounded-full flex items-center justify-center text-white">{index + 1}</div>
                  {index > 0 && (
                    <RemoveConfirmation itemName={o.value} confirmationCallback={remove(o.uuid)}>
                      <TrashIcon className="fill-blue opacity-40 hover:opacity-100 transition-all w-6 cursor-pointer" />
                    </RemoveConfirmation>
                  )}
                </div>
                <div className="flex flex-col w-full">
                  <Input key={o.uuid} value={getOptionValue(o.uuid)} onChange={updateOption(o.uuid)} />
                </div>
              </div>
            ),
          }
        })}
      />
      <Add />
    </div>
  )
}

export default Selection
